import { Link } from "@tanstack/react-router";

import { cn } from "@/lib/classNames";

export type SideNavItem = {
  href: string;
  label: string;
  match: "exact" | "prefix";
};

type SideNavProps = {
  items: readonly SideNavItem[];
  pathname: string;
  label?: string;
  className?: string;
  "data-testid"?: string;
};

function isActive(pathname: string, href: string, match: "exact" | "prefix"): boolean {
  if (match === "exact") {
    return pathname === href;
  }

  return pathname === href || pathname.startsWith(`${href}/`);
}

export function SideNav({ items, pathname, label, className, "data-testid": testId }: SideNavProps) {
  return (
    <nav className={cn("flex flex-col gap-1", className)} aria-label={label} data-testid={testId}>
      {items.map((item) => {
        const active = isActive(pathname, item.href, item.match);
        return (
          <Link
            key={item.href}
            to={item.href}
            className={cn(
              "border-2 px-3 py-2.5 text-[11px] font-semibold uppercase tracking-[0.12em] transition-colors",
              active
                ? "border-neutral-950 bg-neutral-950 text-[#fff7ec] shadow-[4px_4px_0_rgba(19,19,19,0.2)]"
                : "border-transparent text-neutral-800 hover:border-neutral-950/25 hover:bg-white/60",
            )}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
